import axios from './axios'

class Channel {
  getChannel(params) {
    const url = '/resource/live/Channel'
    return axios.post(url, params)
  }
  /***
   * 直播领福利
   */
  getWechatSchemaLink(appId = 34) {
    return axios.post(
      'https://yktapi.emoney.cn/account/WeChat/GetWechatSchemaLink?appId=34&emapp-apikey=zhimakaimen',
      {
        appId: appId,
        path: 'pages/service/service'
      }
    )
  }
}

export default new Channel()
